import React from 'react';
import PropTypes from 'prop-types';
import Teaser from './article/Teaser';

export default class GridTeaser extends React.PureComponent {
    /* eslint-disable react/forbid-prop-types */
    static propTypes = {
        article: PropTypes.object.isRequired,
        theme: PropTypes.object,
        utmParams: PropTypes.object,
        index: PropTypes.number,
    };

    static defaultProps = {
        theme: {},
        index: undefined,
    };

    render() {
        const { article, theme, index, utmParams } = this.props;
        const fullWidthDesktop = (index - 3) % 7 === 0; // every seventh teaser, except from the fourth
        const fullWidthMobile = [true, false, false, true][index % 4]; // every first and fourth

        return (
            <Teaser
                article={article}
                theme={theme}
                utmParams={utmParams}
                fullWidthDesktop={fullWidthDesktop}
                fullWidthMobile={fullWidthMobile}
            />
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/local-components/GridTeaser.js
 **/